<template>
  <div>
    <data-table :service="service"
                service-method="getContracts"
                operations="edit"
                :service-path="servicePath"
                :disable-permission-checks="true"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                ref="table">
      <template v-slot:client="{row}">
        <div class="d-flex align-items-center">
          <base-avatar :name="row.client ? row.client.name : $t('generic.na')">
          </base-avatar>
          <router-link v-if="row.client"
                       :to="`/contacts/clients/${row.client.uuid}`"
                       @click.native.stop=""
                       class="ml-2">{{row.client ? row.client.name : $t('generic.na')}}
          </router-link>
        </div>
      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:valid_till="{row}">
        {{$formatDate(row.valid_till, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:amount="{row}">
        {{row.amount}}
      </template>
      <template v-slot:amount_used="{row}">
        {{row.amount_used}}
      </template>
      <template v-slot:amount_open="{row}">
        {{row.amount_open}}
      </template>
      <template v-slot:active="{row}">
        <status-badge :status="row.active ? $t('generic.active') : $t('generic.inactive')"/>
      </template>
      <template v-slot:job_board="{row}">
        <router-link :to="`/job-board/${getByKey(row, 'product_job_board.job_board.id')}`" @click.native.stop="">
          {{getByKey(row, 'product_job_board.job_board.name')}}
        </router-link>
      </template>
      <template v-slot:product="{row}">
        <router-link :to="`/settings/products/${getByKey(row, 'product_job_board.product_id')}`" @click.native.stop="">
          {{getByKey(row, 'product_job_board.name', $t('generic.na'))}}
        </router-link>
      </template>

    </data-table>
  </div>
</template>
<script>
  import ContractService from 'src/services/ContractService'
  import entities from 'src/config/entities'
  import getByKey from 'lodash/get'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'contract-list',
    data () {
      return {
        service: ContractService,
        entity: entities.CONTRACT,
        FRIENDLY_DATETIME_FORMAT,
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'client',
            label: this.$t('contract.list.labels.client'),
            minWidth: '210px',
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '190px',
            sortable: true,
          },
          {
            prop: 'valid_till',
            label: this.$t('contract.list.labels.validTill'),
            minWidth: '190px',
            sortable: true,
          },
          {
            prop: 'amount',
            label: this.$t('contract.list.labels.total'),
            minWidth: '100px',
            sortable: true,
          },
          {
            prop: 'amount_used',
            label: this.$t('contract.list.labels.used'),
            minWidth: '100px',
            sortable: true,
          },
          {
            prop: 'amount_open',
            label: this.$t('contract.list.labels.open'),
            minWidth: '180px',
            sortable: true,
          },
          {
            prop: 'active',
            label: this.$t('generic.active'),
            minWidth: '80px'
          },
          {
            prop: 'job_board',
            label: this.$t('contract.list.labels.job_board'),
            minWidth: '120px'
          },
          {
            prop: 'product',
            label: this.$t('contract.list.labels.product'),
            minWidth: '140px'
          }
        ]
      },
      servicePath () {
        return `/transactions`
      },
      filters () {
        return [
          {
            key: 'with',
            value: 'client,order'
          },
          {
            key: 'sort',
            value: '+valid_till'
          }
        ]
      }
    },
    methods: {
      getByKey
    }
  }
</script>
<style>
</style>
